import * as React from "react";

const RainbowIcon = ({ color }: any) => (
  <svg viewBox="0 0 100 125" width="50">
    <g>
      <path
        fill={color}
        d="M77.385,72.358h-5.818C69.078,62.729,60.409,55.59,50,55.59s-19.078,7.14-21.566,16.769h-5.819   C25.213,59.617,36.506,50,50,50C63.494,50,74.787,59.617,77.385,72.358z M50,38.821c-19.678,0-36.01,14.601-38.728,33.537h5.693   C19.629,56.501,33.384,44.41,50,44.41c16.615,0,30.371,12.091,33.035,27.948h5.693C86.01,53.422,69.678,38.821,50,38.821z    M50,27.642c-25.852,0-47.205,19.597-50,44.717h5.671C8.428,50.306,27.206,33.231,50,33.231c22.795,0,41.572,17.074,44.328,39.127   H100C97.205,47.238,75.852,27.642,50,27.642z"
      />
    </g>
  </svg>
);
export default RainbowIcon;
